
import { motion } from "framer-motion";
import Header from "../components/Header";
import Footer from "../components/Footer";
import EmailPreview from "../components/EmailPreview";
import EmailTester from "../components/EmailTester";
import EmailSignature from "../components/EmailSignature";

const Sandbox = () => {
  return (
    <div className="min-h-screen bg-[#f9f8f5]">
      <Header />
      
      <main className="pt-20">
        <div className="max-w-[1440px] mx-auto px-4 desktop:px-24 laptop:px-20 tablet:px-12 mobile:px-6 py-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h1 className="text-4xl desktop:text-5xl laptop:text-4xl tablet:text-3xl mobile:text-2xl font-bold text-[#374151] mb-4">
              Email Preview & Testing
            </h1>
            <p className="text-lg text-gray-700 max-w-2xl mx-auto">
              Preview how our emails will look to users and test email sending functionality
            </p>
          </motion.div>

          <div className="grid desktop:grid-cols-2 laptop:grid-cols-2 tablet:grid-cols-1 mobile:grid-cols-1 gap-8 mb-12">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
            >
              <h2 className="text-2xl font-semibold text-[#374151] mb-6">Email Preview</h2>
              <EmailPreview />
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <h2 className="text-2xl font-semibold text-[#374151] mb-6">Test Email Sending</h2>
              <EmailTester />
            </motion.div>
          </div>

          {/* Email Signatures Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="mb-12"
          >
            <h2 className="text-2xl font-semibold text-[#374151] mb-6 text-center">Email Signatures</h2>
            <p className="text-gray-700 text-center mb-8">Choose from these 3 signature designs</p>
            
            <div className="grid desktop:grid-cols-3 laptop:grid-cols-3 tablet:grid-cols-2 mobile:grid-cols-1 gap-8">
              <div className="text-center">
                <h3 className="text-lg font-medium text-[#374151] mb-4">Version 1 - Logo Badge</h3>
                <EmailSignature version={1} isEditable />
              </div>
              
              <div className="text-center">
                <h3 className="text-lg font-medium text-[#374151] mb-4">Version 2 - Centered</h3>
                <EmailSignature version={2} isEditable />
              </div>
              
              <div className="text-center">
                <h3 className="text-lg font-medium text-[#374151] mb-4">Version 3 - Side Panel</h3>
                <EmailSignature version={3} isEditable />
              </div>
            </div>
            
            <div className="mt-8 text-center">
              <p className="text-sm text-gray-600">
                Click on any signature to see it larger. You can customize the contact details for your team.
              </p>
            </div>
          </motion.div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Sandbox;
